export enum DocumentType {
  AOA = 'AOA',
  MOA = 'MOA',
  DRAFT_PROPERTY_MANAGEMENT_AGREEMENT = 'Draft Property Management Agreement',
  RERA_CERTIFICATE = 'RERA Certificate',
  FINANCIAL_YEAR_RECEIPT = 'Financial Year Receipt',
  OWNERSHIP_DOCUMENT = 'Ownership Document',
  OTHER = 'Other',
}
